import {
  NOT_YET_STARTED,
  IN_PROCESS,
  VERIFIER_REVIEW_PENDING,
  VERIFIER_REVIEW_UNDERWAY,
  VERIFIER_REVISION_UNDERWAY,
  VERIFIER_REVISION_REQUESTED,
  REVIEWER_REVIEW_PENDING,
  REVIEWER_REVIEW_UNDERWAY,
  REVIEWER_REVISION_REQUESTED,
  COMPLETED,
} from 'src/utils/data/job';

export const getJobStatusLabel = (status) => {
  switch(status) {
    case NOT_YET_STARTED:
      return 'NOT_YET_STARTED';
    case IN_PROCESS:
      return 'IN_PROCESS';
    case VERIFIER_REVIEW_PENDING:
    case REVIEWER_REVIEW_PENDING:
      return 'REVIEW_PENDING';
    case VERIFIER_REVIEW_UNDERWAY:
    case VERIFIER_REVISION_UNDERWAY:
    case REVIEWER_REVIEW_UNDERWAY:
      return 'REVIEW_UNDERWAY';
    case VERIFIER_REVISION_REQUESTED:
    case REVIEWER_REVISION_REQUESTED:
      return 'REVISION_REQUESTED';
    case COMPLETED:
      return 'COMPLETED';
    default:
      return status;
  }
};

export const actionButtonVisibility = (
  jobStatus, 
  userIsAuthorizedExternalSaqUser,
  isOnlyExternalUser,
  isVerifier, 
  isReviewer, 
  hasUnverifiedSaqService,
  isAdmin
) => {
  // Export attachments button for SAQ verifier/ SAQ Manager / Report reviewer
  const isExportAttachmentsButtonVisible = !isOnlyExternalUser && jobStatus !== NOT_YET_STARTED && jobStatus !== IN_PROCESS;

  // buttons visibility according to job status and user role
  // submit button for external user
  const submitButtonVisibilityStatus = [IN_PROCESS, VERIFIER_REVISION_REQUESTED];
  const isSubmitButtonVisible = ((isAdmin || userIsAuthorizedExternalSaqUser) && submitButtonVisibilityStatus.includes(jobStatus));

  // start button for auditor and reviewer
  const auditorStartButtonVisibilityStatus = [VERIFIER_REVIEW_PENDING, REVIEWER_REVISION_REQUESTED];
  const reviewerStartButtonVisibilityStatus = [REVIEWER_REVIEW_PENDING];
  const isStartButtonVisible = (isVerifier && auditorStartButtonVisibilityStatus.includes(jobStatus)) || (isReviewer && reviewerStartButtonVisibilityStatus.includes(jobStatus));

  // request clarification button for auditor and reviewer
  const auditorRequestClarificationButtonVisibilityStatus = [VERIFIER_REVIEW_UNDERWAY];
  const reviewerRequestClarificationButtonVisibilityStatus = [REVIEWER_REVIEW_UNDERWAY];
  const isRequestClarificationButtonVisible = (isVerifier && auditorRequestClarificationButtonVisibilityStatus.includes(jobStatus)) || (isReviewer && reviewerRequestClarificationButtonVisibilityStatus.includes(jobStatus));

  // submit for review button
  const submitForReviewButtonVisibilityStatus = [VERIFIER_REVIEW_UNDERWAY, VERIFIER_REVISION_UNDERWAY];
  const isSubmitForReviewButtonVisible = !hasUnverifiedSaqService && isVerifier && submitForReviewButtonVisibilityStatus.includes(jobStatus);

  // complete button
  const reviewerCompleteButtonVisibilityStatus = [REVIEWER_REVIEW_UNDERWAY];
  const auditorCompleteButtonVisibilityStatus = [VERIFIER_REVIEW_UNDERWAY];
  const isCompleteButtonVisible = ((isReviewer && reviewerCompleteButtonVisibilityStatus.includes(jobStatus)) || (hasUnverifiedSaqService && isVerifier && auditorCompleteButtonVisibilityStatus.includes(jobStatus)));

  return {
    isSubmitButtonVisible,
    isStartButtonVisible,
    isRequestClarificationButtonVisible,
    isSubmitForReviewButtonVisible,
    isCompleteButtonVisible,
    isExportAttachmentsButtonVisible
  };
};
